import { render, staticRenderFns } from "./AcceptRequest.vue?vue&type=template&id=1dd53893&"
import script from "./AcceptRequest.vue?vue&type=script&lang=js&"
export * from "./AcceptRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports